/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getPersonalLoanById,
  updatePersonalLoan,
  getAllAdmins,
  getPersonalLoanByMobile,
  getAllCities,
  getAllStates,
  getAllPincode,
  getPersonalLoanByEmail,
  getAllPersonalLoanBanks,
  getAllCompanies,
  getPersonalLoanBankList,
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { useForm, FormProvider, set } from "react-hook-form";
import { Stepper, Step, StepLabel, Input } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../../assets/logo.png";
import { FaTrashAlt } from "react-icons/fa";
import CreateCompanyModal from "../Company/CreateComapnyModal";


const EditPersonalLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [filteredStates, setFilteredStates] = useState([]);
  const [error, setError] = useState(null);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [mobileExists, setMobileExists] = useState(false);
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [officeState, setOfficeState] = useState(null);
  const [officeCityOptions, setOfficeCityOptions] = useState([]);
  const [officePincodeOptions, setOfficePincodeOptions] = useState([]);
  const [companyId, setCompanyId] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState([]);
  const [companyName, setCompanyName] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [personalLoanBanks, setPersonalLoanBanks] = useState([]);
  const [files, setFiles] = useState({});
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const fileRefs = {
    pan: useRef(null),
    aadhar: useRef(null),
    photo: useRef(null),
    pay_slip: useRef(null),
    account_statement: useRef(null),
    others: useRef(null),
  };

  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
      created_id: "",
      created_by: "",
      assigned_to: "",
      status: "",
      rejected_reason: "",
      name: "",
      dob: "",
      age: "",
      mobile: "",
      email: "",
      company_type: "",
      net_salary: "",
      existing_emi_amount: "",
      company_name: "",
      address: "",
      state: "",
      city: "",
      pincode: "",
      required_loan_amount: "",
      office_address: "",
      office_state: "",
      office_city: "",
      office_pincode: "",
      mother_name: "",
      father_name: "",
      residence_type: "",
      maritalStatus: "",
      spouse_name: "",
      landmark: "",
      present_address_adhaar: "",
      present_address: "",
      present_state: "",
      present_city: "",
      present_pincode: "",
      present_landmark: "",
      total_emi_amount: "",
      type_your_designation: "",
      total_experience: "",
      add_reference: "",
      reference_name: "",
      reference_mobile: "",
      reference_address: "",
      reference_location: "",
      Other: "",
      bank_name: "",
      others_company: "",
      panCard: null,
      aadhaarCard: null,
      photo: null,
      Payslip: null,
      AccountStatement: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch("dob");
  const selectedStatus = watch("status");

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getPersonalLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
        setSelectedState(loan.state);
        setPresentState(loan.present_state);
        setOfficeState(loan.office_state);
        setCompanyName(loan.company_name);
        setBankName(loan.bank_name);
      } catch (error) {
        console.error("Error fetching personal loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!officeState) {
      setOfficeCityOptions([]);
      setOfficePincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === officeState
      );

      const officeCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setOfficeCityOptions(officeCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === officeState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setOfficePincodeOptions(uniqueOptions);
    }
  }, [selectedState, presentState, officeState, cities, pincodenumber]);

  useEffect(() => {
    if (companyLists.length > 0 && companyName) {
      const matchedCompany = companyLists.find(c => c.label === companyName);
      if (matchedCompany) {
        setCompanyId(matchedCompany.value);
      }
    }
  }, [companyLists, companyName]);

  const fetchCompanies = async () => {
    try {
      const response = await getAllCompanies();
      const companyData = response.data.map((company) => ({
        value: company.company_id,
        label: company.company_name,
      }));
      companyData.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyLists(companyData);
      const matchedCompany = companyData.find(c => c.label === companyName);
    if (matchedCompany) {
      setCompanyId(matchedCompany.value); 
    }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    const fetchPersonalLoanBanks = async () => {
      try {
        const response = await getPersonalLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setPersonalLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching personal loan banks:", error);
      }
    };
    fetchPersonalLoanBanks();
  }, []);
  
  useEffect(() => {
    const id =
      Array.isArray(selectedCompanyId) && selectedCompanyId.length === 0
        ? companyId
        : selectedCompanyId || companyId;
    if (!id || (Array.isArray(id) && id.length === 0)) return;
    const fetchCompanyByIdWithBanks = async () => {
      try {
        const response = await getAllPersonalLoanBanks(id);
        const bankList = response.data.bank_list;

        const formattedBanks = bankList.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));

        setBankLists(formattedBanks);
      } catch (error) {
        console.error("Error fetching bank:", error);
      }
    };

    fetchCompanyByIdWithBanks();
  }, [selectedCompanyId, companyId]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleOfficeStateChange = (selectedOption) => {
    setOfficeState(selectedOption?.value || null);
    setValue("office_state", selectedOption?.value || "");
  };

  const getSelectedOfficeStateValue = () => {
    return stateOptions.find((option) => option.value === officeState);
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompanyId(selectedOption?.value || null);
    setCompanyName(selectedOption?.label || null);
    setValue("company_name", selectedOption?.label || "");
    setBankName("");
    setValue("bank_name", "");
  };

  const getSelectedCompanyValue = () => {
    return companyLists.find((option) => option.label === companyName);
  };

  const handleBankChange = (selectedOption) => {
    setBankName(selectedOption?.value || null);
    setValue("bank_name", selectedOption?.value || "");
  };

  const getSelectedBankValue = () => {
    return bankLists.find((option) => option.value === bankName) || null;
  };

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getPersonalLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

    useEffect(() => {
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      setValue("age", age); 
    }
  }, [dob, setValue]);

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getPersonalLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  if (error) {
    return <div>{error}</div>;
  }

  const handleCompanyButtonClick = () => {
     setIsViewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updatePersonalLoan(id, formDataToSend);
      setLoading(false);
      navigate("/personalloanlist", {
        state: { successMessage: "Personal loan updated successfully!" },
      });
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === "string") {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
        }
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error(
            "Mobile number or email already exists. Please use different details."
          );
        }
      } else {
        setLoading(false);
        console.error("Error updating personal loan:", error);
        toast.error("Failed to update the personal loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getPersonalLoanById(id);

      let url = loan[documentType];

      if (url) {
        url = decodeURIComponent(url);
        window.open(url, "_blank");
      } else {
        toast.warn(`No file available`);
        console.warn(`No URL found for document type: ${documentType}`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };

  const handleDownloadClick = async (documentType) => {
    try {
      const loan = await getPersonalLoanById(id);
      let url = loan[documentType];

      if (!url) {
        toast.warn("No file available");
        return;
      }

      url = decodeURIComponent(url);

      // Auto-upgrade to HTTPS in production
      if (window.location.hostname !== "localhost" && url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }

      // Fetch blob if local or same-origin, otherwise direct link download
      const isLocalOrSameOrigin = url.startsWith(window.location.origin) || window.location.hostname === "localhost";

      if (isLocalOrSameOrigin) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch the document");
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${documentType}_${id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

      } else {
        // Cross-origin server file
        const link = document.createElement("a");
        link.href = url;
        const fileName = url.split("/").pop() || `${documentType}_${id}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    } catch (error) {
      console.error(`Error downloading ${documentType} document:`, error);
      toast.error("Failed to download document");
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };
  
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      <div className="edit-back-icon">
        {activeStep === 0 && (
          <div
            className="edit-back-text"
            onClick={() => navigate("/personalloanlist")}
          >
            &lt; Go Back
          </div>
        )}
        <img src={logo} alt="Logo" className="form-logo" />
      </div>

      <h2>Personal Loan</h2>
      <FormProvider {...methods}>
        {loading}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      label="Loan ID"
                      name="form_id"
                      disabled={true}
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#808080",
                      }}
                      registerOptions={{}}
                    />
                  </Col>
                  {adminRole !== "customer" && ( 
                    <>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee ID"
                          name="created_id"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                          registerOptions={{}}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee"
                          name="created_by"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                          registerOptions={{}}
                        />
                      </Col>
                    </>
                  )}
                  {adminRole === "admin" && (
                    <Col md={6}>
                      <LabeledSelect
                        name="assigned_to"
                        label="Assign to"
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.assigned_to?.message}
                        options={employeeOptions}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="status"
                      label="Lead Status"
                      options={[
                        { value: "Open", label: "Open" },
                        { value: "In Process", label: "In Process" },
                        { value: "Pending", label: "Pending" },
                        { value: "Approved", label: "Approved" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      registerOptions={{
                        required: "Selection is required",
                        onChange: (e) => {
                          handleStatusChange(e);
                          setValue("status", e.target.value);
                        },
                      }}
                      disabled={adminRole === "customer"}
                      error={errors.status?.message}
                      required
                    />
                  </Col>
                  {watch("status") === "Rejected" && (
                    <Col md={6}>
                      <LabeledDropDown
                        name="rejected_reason"
                        label="Rejected Reason"
                        options={[
                          {
                            value: "CIBIL issue & more than 3 enquiries",
                            label: "CIBIL issue & more than 3 enquiries",
                          },
                          {
                            value: "Recent loan/settlement",
                            label: "Recent loan/settlement",
                          },
                          { value: "Recent DPD", label: "Recent DPD" },
                          {
                            value: "Overdue / Previous loan (HL/PL/BL/CL)",
                            label: "Overdue / Previous loan (HL/PL/BL/CL)",
                          },
                          {
                            value: "Lowest CIBIL score",
                            label: "Lowest CIBIL score",
                          },
                          {
                            value: "Guarantor CIBIL score / Co-Applicant issue",
                            label: "Guarantor CIBIL score / Co-Applicant issue",
                          },
                          {
                            value: "Pincode / Salary / Age criteria not met",
                            label: "Pincode / Salary / Age criteria not met",
                          },
                          {
                            value: "Can apply after 3 months",
                            label: "Can apply after 3 months",
                          },
                          {
                            value: "Never eligible for loan",
                            label: "Never eligible for loan",
                          },
                          {
                            value: "Credit card overdue",
                            label: "Credit card overdue",
                          },
                          {
                            value: "Property Legal issue",
                            label: "Property Legal issue",
                          },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.rejected_reason?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      name="name"
                      label="Name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Date of Birth"
                      type="date"
                      name="dob"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Age"
                      type="number"
                      name="age"
                      readOnly
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Mobile"
                      type="tel"
                      name="mobile"
                      registerOptions={validationRules.mobile}
                      error={errors.mobile?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="email"
                      label="Personal Email ID"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.fieldRequired(
                        "Mother Name"
                      )}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.fieldRequired(
                        "Father Name"
                      )}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        { value: "Owned", label: "Owned" },
                        { value: "Rent", label: "Rent" },
                        {
                          value: "OwnedByMe/Spouse",
                          label: "Owned by Me / Spouse",
                        },
                        { value: "OwnedbyMyParents", label: "Owned by My Parents" },
                        { value: "PG/Hostel", label: "PG / Hostel" },
                        { value: "CompanyProvide", label: "Company Provide" },
                        {
                          value: "BachelorAccommodation",
                          label: "Bachelor Accommodation",
                        },
                        { value: "Others", label: "Others" },
                      ]}
                      registerOptions={{
                        required: "Residence Type is required",
                      }}
                      error={errors.residence_type?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="maritalStatus"
                      label="Marital Status"
                      options={[
                        { value: "single", label: "Single" },
                        { value: "married", label: "Married" },
                        { value: "divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("maritalStatus", e.target.value);
                        },
                      }}
                      error={errors.maritalStatus?.message}
                    />
                  </Col>
                  {watch("maritalStatus") === "married" && (
                    <Col md={6}>
                      <LabeledInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.fieldRequired(
                          "Spouse Name"
                        )}
                        error={errors.spouse_name?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      type="text"
                      name="address"
                      label="Present Staying Address"
                      registerOptions={{ required: "Address is required" }}
                      error={errors.address?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="landmark"
                      type="text"
                      label="Landmark"
                      registerOptions={{ required: "Landmark is required" }}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelectAgent
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="present_address_adhaar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.present_address_adhaar?.message}
                      required
                    />
                  </Col>
                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="present_address"
                          label="Present Aadhaar Address"
                          registerOptions={{
                            required: "Present Address is required",
                          }}
                          error={errors.present_address?.message}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_city"
                          label="City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="present_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                          error={errors.present_pincode?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="present_landmark"
                          label="Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.present_landmark?.message}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}
            {activeStep === 1 && (
              <div className="sections requested-loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="text"
                      registerOptions={validationRules.loanAmount}
                      error={errors.required_loan_amount?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="existing_emi_amount"
                      label="Existing EMI"
                      type="text"
                      registerOptions={{
                        required: "This selection is required",
                        pattern: validationRules.validNumber.pattern,
                      }}
                      error={errors.existing_emi_amount?.message}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <LabeledSelect
                      name="company_name"
                      label="Working Company Name"
                      options={companyLists}
                      value={getSelectedCompanyValue()}
                      onChange={handleCompanyChange}
                    />
                  </Col>
                  {watch("company_name") === "Others" && (
                    <Col md={6}>
                      <LabeledInput
                        name="others_company"
                        label="Other's Company Name"
                      />
                    </Col>
                  )}
                   {adminRole !==  "customer" &&
                   (watch("company_name") === "Others" || bankLists.length < 1) &&  (
                      <Col md={6}>
                        <LabeledSelect
                          name="bank_name"
                          label="Bank Name"
                          options={personalLoanBanks}
                        />
                      </Col>
                    )}
                  {adminRole !==  "customer" &&
                   (watch("company_name") !== "Others" && bankLists.length > 0) && (
                    <Col md={6}>
                      <LabeledSelect
                        name="bank_name"
                        label="Bank Name"
                        options={bankLists}
                        value={getSelectedBankValue()}
                        onChange={handleBankChange}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="company_type"
                      label="Company Type"
                      options={[
                        {
                          value: "PrivateLimited",
                          label: "Private Limited",
                        },
                        { value: "PublicLimited", label: "Public Limited" },
                        { value: "State", label: "State Government" },
                        { value: "CentralGovt", label: "Central Government" },
                        {
                          value: "Proprietorship",
                          label: "Proprietorship",
                        },
                        { value: "Partnership", label: "Partnership" },
                        { value: "LLP", label: "LLP" },
                        { value: "Others", label: "Others" },
                      ]}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="type_your_designation"
                      label="Type Your Designation"
                      registerOptions={{
                        required: "Type your Designation is required",
                      }}
                      error={errors.type_your_designation?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Net Salary"
                      type="text"
                      name="net_salary"
                      registerOptions={{
                        required: "Net Salary is required",
                        pattern: validationRules.validNumber.pattern,
                        validate: (value) =>
                          value >= 15000 || "Net Salary must allowed 15,000",
                      }}
                      error={errors.salary?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="is_pf_deducted"
                      label="Are You Looking for Balance Transfer?"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "Select PF Deduction Status",
                      }}
                      error={errors.is_pf_deducted?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="total_experience"
                      label="Total years of Experience"
                      registerOptions={{ required: "Experience is required" }}
                      error={errors.total_experience?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="office_address"
                      label="Office Address"
                      registerOptions={{
                        required: "Office Address is required",
                      }}
                      error={errors.office_address?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="office_landmark"
                      label="Office Landmark"
                      registerOptions={{
                        required: "Office Landmark is required",
                      }}
                      error={errors.office_landmark?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="office_state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedOfficeStateValue()}
                      onChange={handleOfficeStateChange}
                      registerOptions={{ required: "State is required" }}
                      error={errors.office_state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="office_city"
                      label="City"
                      options={officeCityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.office_city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelectAgent
                      name="office_pincode"
                      label="Pincode"
                      options={officePincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>
                </Row>
                <h4>Reference Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_name"
                      label="Reference Name"
                      type="text"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_mobile"
                      label="Reference Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_address"
                      label="Reference Address"
                      type="text"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_location"
                      label="Location"
                      type="text"
                    />
                  </Col>
                </Row>
              </div>
            )}
            {activeStep === 2 && (
              <div className="sections document-upload-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label
                        htmlFor="photo"
                        className="document-label required"
                      >
                        Photo
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.photo}
                          label="Photo"
                          type="file"
                          name="photo"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("photo")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("photo")}
                        >
                          Download
                        </button>
                      </div>
                    </div>

                    <div className="document-upload-group">
                      <label
                        htmlFor="aadhar"
                        className="document-label required"
                      >
                        Aadhaar /eAadhaar
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.aadhar}
                          label="Aadhar Card"
                          type="file"
                          name="aadhar"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.aadhar && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("aadhar")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("aadhar")}
                        >
                          Download
                        </button>
                      </div>
                    </div>

                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label required">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.pan}
                          label="PAN Card"
                          type="file"
                          name="pan"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.pan && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("pan")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("pan")}
                        >
                          Download
                        </button>
                      </div>
                    </div>

                    <div className="document-upload-group">
                      <label htmlFor="pay_slip" className="document-label">
                        Pay Slip (Last 3 Months)
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.pay_slip}
                          label="Payslip"
                          type="file"
                          name="pay_slip"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.pay_slip && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pay_slip")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("pay_slip")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("pay_slip")}
                        >
                          Download
                        </button>
                      </div>
                    </div>

                    <div className="document-upload-group">
                      <label
                        htmlFor="account_statement"
                        className="document-label required"
                      >
                        Account Statement (Last 6 Month )
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.account_statement}
                          type="file"
                          name="account_statement"
                          onChange={handleFileChange}
                          className="form-control-file"
                          accept=".pdf"
                        />
                        {files.account_statement && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("account_statement")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("account_statement")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() =>
                            handleDownloadClick("account_statement")
                          }
                        >
                          Download
                        </button>
                      </div>
                      <span className="file-upload-message">
                        Upload only PDF files & without password
                      </span>
                    </div>

                    <div className="document-upload-group">
                      <label
                        htmlFor="others"
                        className="document-label"
                      >
                        Others
                      </label>
                      <Col md={12} className="document-dropdown-file">
                        <LabeledSelect
                          name="Other"
                          options={[
                            { value: "Employee ID", label: "Employee ID" },
                            { value: "Form16", label: "Form 16" },
                            { value: "Form26AS", label: "Form 26 AS" },
                            {
                              value: "Previous Loan Statement",
                              label: "Previous Loan Statement",
                            },
                          ]}
                        />
                        </Col>
                        <div className="document-file-container">
                          <input
                            ref={fileRefs.others}
                            type="file"
                            name="others"
                            onChange={handleFileChange}
                            className="form-control-file"
                          />
                          {files.others && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("others")}
                            />
                          )}
                        </div>
                        <div className="button-group">
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleViewClick("others")}
                          >
                            View
                          </button>
                          <button
                            type="button"
                            className="view-btn"
                            onClick={() => handleDownloadClick("others")}
                          >
                            Download
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 &&
                  !(adminRole === "customer" && selectedStatus === "Approved") && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Update"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <CreateCompanyModal           
        isOpen={isViewModalOpen}
        onClose={handleCloseModal}
        onCompanyCreated={fetchCompanies} 
      />
      <ToastContainer />
    </div>
  );
};
export default EditPersonalLoan;